import SeparateLine from '@/shared/Forms/SeparateLine'
import css from '@/pages/Processes/Maintenance/MaintenanceProcesses/components/MaintenanceProcessSidePage/maintenanceProcessSidePage.module.css'
import EquipmentModelsTags from '@/pages/Equipment/pages/EquipmentModels/components/EquipmentModelsTags'
import { IMaintenanceProcess, IMaintenanceProcessRule } from '@/pages/Processes/Maintenance/maintenance.types.ts'
import FormEditButton from '@/shared/Buttons/FormEditButton'
import FormDeleteButton from '@/shared/Buttons/FormDeleteButton'
import useMaintenanceProcess from '@/pages/Processes/Maintenance/hooks/useMaintenanceProcess.ts'
import { useRecoilValue } from 'recoil'
import maintenanceBlankSchemasAtom from '@/pages/Processes/Maintenance/MaintenanceBlanks/maintenanceBlankSchemas.atom.ts'
import confirmService from '@/services/ConfirmService/confirm.service.ts'
import maintenanceApi from '@/pages/Processes/Maintenance/maintenance.api.ts'
import maintenanceEvents from '@/pages/Processes/Maintenance/events/maintenance.events.ts'
import ProtectedContent from '@/services/rights/ProtectedContent'

interface IProps {
  processId: IMaintenanceProcess['id']
  onEdit: () => void
  onClose: () => void
}

const ViewMaintenanceProcessSidePageContent = (props: IProps) => {
  const process = useMaintenanceProcess(props.processId)
  const blanks = useRecoilValue(maintenanceBlankSchemasAtom).items

  const handleDelete = () => {
    confirmService.requestConfirm({
      description: `Подтвердите удаление процесса ${process.name}`,
      buttonType: 'primary',
      onConfirm: () =>
        maintenanceApi
          .deleteMaintenanceProcess(props.processId)
          .then((r) => r.status === 'success' && maintenanceEvents.processDeleted(r.body.id))
          .then(() => props.onClose()),
    })
  }

  const renderBlankLink = (period: IMaintenanceProcessRule['period']) => {
    const rule = process.rules.find((r) => r.period === period)
    if (!rule) return <span className="text-nm">-</span>

    const blank = blanks.find((b) => b.id === rule.blankSchemaId)
    if (!blank) return <span className="text-nm">-</span>

    return <span className="text-nm text-link">{blank.name}</span>
  }

  return (
    <div className="flex-lines gap16" style={{ height: '100%' }}>
      <h2 className="text-heading-4">{process.name}</h2>
      <SeparateLine />
      <div className={css.maintenanceProcessSidePageGrid}>
        <p className="text-nm text-secondary">Модели лифтов:</p>
        <div className="inline-flex-gap gap4" style={{ flexWrap: 'wrap' }}>
          <EquipmentModelsTags ids={process.equipmentModels} />
        </div>
      </div>
      <SeparateLine />
      <h5 className="text-heading-5">Правила обслуживания</h5>
      <div className={css.maintenanceProcessSidePageGrid}>
        <p className="text-nm text-secondary">1 месяцц:</p>
        <p className="text-nm">{renderBlankLink('M1')}</p>
        <p className="text-nm text-secondary">3 месяца:</p>
        <p className="text-nm">{renderBlankLink('M3')}</p>
        <p className="text-nm text-secondary">6 месяцев:</p>
        <p className="text-nm">{renderBlankLink('M6')}</p>
        <p className="text-nm text-secondary">9 месяцев:</p>
        <p className="text-nm">{renderBlankLink('M9')}</p>
        <p className="text-nm text-secondary">12 месяцев:</p>
        <p className="text-nm">{renderBlankLink('M12')}</p>
      </div>

      <ProtectedContent requiredRight="mdm:update_schema">
        <div style={{ marginTop: 'auto' }}>
          <SeparateLine />
        </div>
        <div className="inline-flex-gap gap8">
          <FormEditButton onClick={props.onEdit} />
          <ProtectedContent requiredRight="mdm:delete_schema">
            <FormDeleteButton onClick={handleDelete} />
          </ProtectedContent>
        </div>
      </ProtectedContent>
    </div>
  )
}

export default ViewMaintenanceProcessSidePageContent
